import {NgModule} from "@angular/core";

import {HomeComponent} from "./home.component";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule, Routes} from "@angular/router";
import {Http} from "@angular/http";
import {HomeLoginFormComponent} from "./login/home-login-form.component";
import {HomeSignupFormComponent} from "./signup/home-signup-form.component";
import {HomeForgotpasswordComponent} from "./forgotpassword/home-forgotpassword-form.component";
import {HomeResetpasswordComponent} from "./resetpassword/home-resetpassword-form.component";

const appRoutes: Routes = [
    { path: 'home', component: HomeComponent },
    { path: 'logout', component: HomeComponent }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forChild(appRoutes)
    ],
    declarations: [
        HomeComponent,
        HomeLoginFormComponent,
        HomeSignupFormComponent,
        HomeForgotpasswordComponent,
        HomeResetpasswordComponent
    ],
    exports: [
        HomeComponent,
        HomeLoginFormComponent,
        HomeSignupFormComponent,
        HomeForgotpasswordComponent,
        HomeResetpasswordComponent
    ]
})
export class HomeModule{

}


// WEBPACK FOOTER //
// ./src/app/front/home/home.module.ts